export function isNullOrUndefined<T>(obj: T): boolean {
  return obj === null || obj === undefined;
}
export function compareIgnoringCase(string1: string, string2: string): number {
  return string1 === string2
    ? 0
    : !string1
    ? -1
    : !string2
    ? 1
    : string1.localeCompare(string2, undefined, { sensitivity: 'accent' });
}

export function equalsIgnoringCase(string1: string, string2: string): boolean {
  return compareIgnoringCase(string1, string2) === 0;
}
export function isNullOrUndefinedOrEmpty<T>(obj: T): boolean {
  return obj === null || obj === undefined || Object.entries(obj).length === 0;
}
